import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBranding } from "../../context/BrandingContext";

const GoogleAnalytics = () => {
    const location = useLocation();
    const { variables } = useBranding();

    // Default fallback if not defined in variables
    // const DEFAULT_GA_ID = "G-XYHYM1C8Q8";
    const GA_TRACKING_ID = variables?.GA_TRACKING_ID;
    //  || DEFAULT_GA_ID;

    useEffect(() => {
        if (!GA_TRACKING_ID) return;

        // Load the script
        const script = document.createElement("script");
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
        script.async = true;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", GA_TRACKING_ID, {
            cookie_flags: 'SameSite=None;Secure',
            cookie_domain: 'auto'
        });

        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
        };
    }, [GA_TRACKING_ID]);

    useEffect(() => {
        if (window.gtag && GA_TRACKING_ID) {
            window.gtag("config", GA_TRACKING_ID, {
                page_path: location.pathname + location.search,
                cookie_domain: 'auto'
            });
        }
    }, [location, GA_TRACKING_ID]);

    return null;
};

export default GoogleAnalytics;
